import { C } from '../../styles/tokens';
import useIsMobile from '../../hooks/useIsMobile';

// Matches AudioAssetsList.tsx's own row grid — desktopCols on desktop, or the same
// '1fr auto' 2-column layout + hidden header row AudioAssetsList switches to on mobile
// (AudioAssetsList.tsx:266,234) — used by Sound Effects and Music.
export default function AudioAssetsSkeleton({ compact = false, rows = 6 }) {
    const isMobile = useIsMobile();
    const desktopCols = compact ? '1fr 200px 70px' : '1fr 200px 70px 90px 116px';
    const gridTemplateColumns = isMobile ? '1fr auto' : desktopCols;

    return (
        <div>
            {Array.from({ length: rows }).map((_, i) => (
                <div
                    key={i}
                    style={{
                        display: 'grid', gridTemplateColumns, gap: 12, alignItems: 'center',
                        padding: '9px 12px', borderTop: i > 0 ? `1px solid ${C.n100}` : 'none',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
                        <div className="shine rounded-3" style={{ width: 40, height: 40, flexShrink: 0 }} />
                        <div className="shine rounded-2" style={{ height: 13, width: '55%' }} />
                    </div>
                    {isMobile ? (
                        <div className="shine rounded-3" style={{ width: 32, height: 32 }} />
                    ) : (
                        <>
                            <div className="shine rounded-2" style={{ height: 24, width: '100%' }} />
                            <div className="shine rounded-2" style={{ height: 11, width: '60%' }} />
                            {!compact && <div className="shine rounded-2" style={{ height: 11, width: '70%' }} />}
                            {!compact && <div className="shine rounded-2" style={{ height: 26, width: '80%' }} />}
                        </>
                    )}
                </div>
            ))}
        </div>
    );
}
